import script from "./CreateNewAccountDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateNewAccountDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateNewAccountDialog.vue?vue&type=style&index=0&id=4e9a394e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9a394e"]])

export default __exports__